
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import useWindowSize from '../../_hooks/useWindowSize';
import Grid from "@mui/material/GridLegacy";
import Box from "@mui/material/Box";
import React from 'react';
import { getBrand } from '@components/config/helpers';

// const Categories2 = dynamic(() => import('../SideMenu/Categories2'))
const Categories3 = dynamic(() => import('../SideMenu/Categories3'))
const VenueSelector = dynamic(() => import('../Reusables/VenueSelector'), { ssr: false })

const SideNav2 = ({ route }) => {
    const { isMobile } = useWindowSize()
    const filteredCategories = useSelector(state => state.globalReducer.prettified_categories);
    const pricing_model = useSelector((state) => state.globalReducer.pricing_model);
    // const filteredCategories = useMemo(() => {
    //     return prettified_categories.filter(category => category.parent_id === 0 && category.visible === 'yes');
    // }, [prettified_categories]); // Dependencies array


    return (
        <Grid sx={{
            display: {
                xs: 'none',
                md: 'block'
            },
            height: 'fit-content',
        }} xs={12} lg={3} xl={2} item>
            {/* <Categories2 route={route} prettified_categories={prettified_categories} /> */}
            {!isMobile && (
                <>
                    <Categories3 route={route} prettified_categories={filteredCategories} />
                    {pricing_model == 1 && (
                        <Box
                            className="pl-1 pr-1"
                        >
                            <VenueSelector
                                className="mt-3 mr-2 light-border"
                                title="Select Your Venue"
                                titleClass="text-center"
                                gridContainerClass='justify-center'
                                elevation={0}
                                showGrid={{
                                    xs: 12
                                }}
                                venueGrid={{
                                    xs: 12
                                }}
                            />
                        </Box>
                    )}
                </>
            )
            }

        </Grid>
    )
}

export default React.memo(SideNav2)